import { useEffect } from 'react';
import { HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr';
import type { UserScoreResponse } from '@routes/sidebar/learning/api/learning.api.ts';
import { getPoints } from '@routes/sidebar/learning/model/learning.slice.ts';
import { readToken } from '@store/services/localStorage.service.ts';
import { buildClientHubBaseUrl } from '@utils/clientExtractor.ts';

import { useAppDispatch } from './reduxHooks.ts';

const HUB_PATH = '/hubs/v1/user-gamification';
const GAMIFICATION_UPDATED_EVENT = 'GamificationUpdated';

export const useUserGamificationHub = () => {
    const dispatch = useAppDispatch();
    const token = readToken();

    useEffect(() => {
        if (!token) {
            return;
        }

        const connection = new HubConnectionBuilder()
            .withUrl(`${buildClientHubBaseUrl()}${HUB_PATH}`, {
                accessTokenFactory: () => readToken() ?? '',
            })
            .withAutomaticReconnect()
            .configureLogging(LogLevel.Warning)
            .build();

        connection.on(GAMIFICATION_UPDATED_EVENT, (payload: UserScoreResponse) => {
            dispatch(getPoints.fulfilled(payload, 'signalr-gamification', undefined));
        });

        void dispatch(getPoints());
        void connection.start().catch(() => {});

        return () => {
            connection.off(GAMIFICATION_UPDATED_EVENT);
            if (connection.state !== HubConnectionState.Disconnected) {
                void connection.stop();
            }
        };
    }, [dispatch, token]);
};
